import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { Box } from '../../Box/index.js';
import { MainNavItemBody } from '../MainNavItemBody/index.js';
import { useMainNavItem } from '../useMainNavItem.js';

var MainNavButton = forwardRef(function (_a, forwardedRef) {
    var decor = _a.decor, description = _a.description, icon = _a.icon, label = _a.label, _b = _a.notify, notify = _b === void 0 ? false : _b, props = __rest(_a, ["decor", "description", "icon", "label", "notify"]);
    var forwardProps = useMainNavItem(props);
    return (jsx(Box, __assign({ component: "button", ref: forwardedRef, title: label }, forwardProps, (description && { "data-with-description": true }), { children: jsx(MainNavItemBody, { description: description, icon: icon, label: label, decor: decor, notify: notify }) })));
});
MainNavButton.displayName = "MainNavButton";

export { MainNavButton };
//# sourceMappingURL=MainNavButton.js.map
